import React from 'react';
import classNames from 'classnames';

import { CLIENT_ACCIDENT_INSURANCE_FORM } from 'src/constants/FormNames';
import { ACCIDENT_INSURANCE_MENU } from 'src/constants/Generals';
import { TextField, SelectField, Label, RadioField } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import * as CssClassNames from 'src/constants/CssClassNames';
import { digitFloatingNumber, isAccidentInsuranceRateFormat } from 'src/utils/CustomValidators';
import { sumFloatNumberFixed5, toFloatString } from 'src/utils/Utils';
import InsuranceSetting from 'src/features/Clients/components/InsuranceSetting';
import ErrorsSection from 'src/components/ErrorsSection';
import InsurancePeriodSetting from 'src/components/InsurancePeriodSetting';
import OrganizationNumber from './OrganizationNumber';

import styles from './AccidentInsuranceCreatingForm.scss';

const updateFields = [
  'generalRateForEmployee',
  'generalRateForEmployer',
  'insuranceType',
  'organizationNumber',
  'organizationNumberPart0',
  'organizationNumberPart1',
  'organizationNumberPart2',
  'organizationNumberPart3',
  'organizationNumberPart4',
  'premiumRateForEmployee',
  'premiumRateForEmployer',
  'isInput'
];

const fetchRatesBySubtypeType = (occupationalAccidentInsurances, selectedInsuranceType, subtypeType) => {
  if (!selectedInsuranceType) {
    return [];
  }
  const filteredOccupationalAccidentInsurance = occupationalAccidentInsurances.find(
    item => item.id === selectedInsuranceType
  );
  return (
    filteredOccupationalAccidentInsurance.occupationalAccidentInsuranceSubtypes.find(
      item => item.subtypeType === subtypeType
    ) || {}
  );
};

const formatDefaultRates = occupationalAccidentInsuranceRates =>
  occupationalAccidentInsuranceRates.map(rate => ({
    settingStartDate: rate.applyStartDate,
    premiumRateForEmployee: rate.defaultRateForEmployee,
    premiumRateForEmployer: rate.defaultRateForEmployer
  }));

const AccidentInsuranceCreatingForm = props => {
  const {
    submit,
    submitting,
    handleSubmit,
    errors,
    insuranceTypes,
    selectedInsuranceType,
    settingStartDate,
    premiumRateForEmployee,
    premiumRateForEmployer,
    handleInsuranceTypeChange,
    isFirstSet,
    isInput,
    changeIsInput
  } = props;

  const occupationalAccidentInsuranceRates = fetchRatesBySubtypeType(
    insuranceTypes,
    selectedInsuranceType,
    'insurance_premium'
  );

  const defaultInsuranceRates = formatDefaultRates(occupationalAccidentInsuranceRates.insuranceRate || []);
  return (
    <div className={styles.wrap}>
      <InsuranceSetting activeMenu={ACCIDENT_INSURANCE_MENU}>
        <form
          onSubmit={handleSubmit}
          className={classNames(
            CssClassNames.FORM,
            CssClassNames.CLIENT_INSURANCE_FORM,
            CssClassNames.CLIENT_ACCIDENT_INSURANCE
          )}
        >
          <ErrorsSection errors={errors} />

          <OrganizationNumber />
          <div className={styles.inner}>
            {!isFirstSet && (
              <InsurancePeriodSetting
                formName={CLIENT_ACCIDENT_INSURANCE_FORM}
                fieldName="settingStartDate"
                updateFields={updateFields}
                insuranceType="accidentInsurance"
                defaultInsuranceRates={defaultInsuranceRates}
              />
            )}
            <SelectField
              required
              label="業種"
              note={
                <p>
                  詳細については<a
                    href="http://www.mhlw.go.jp/bunya/roudoukijun/rousaihoken.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    厚生労働省HP
                  </a>をご覧ください。
                </p>
              }
              noteWidth={280}
              name="insuranceType"
              options={insuranceTypes}
              onChange={(e, type) => {
                const newType = parseInt(type, 10);
                // 現在選択している値と異なるときのみ更新
                if (selectedInsuranceType !== newType) {
                  // 業種を変えたら手入力フラグは初期化する
                  changeIsInput(false);
                  handleInsuranceTypeChange(newType, settingStartDate, insuranceTypes);
                }
              }}
            />
            <Label text="保険料率" />
            {selectedInsuranceType && (
              <div className={styles.taxRate}>
                <RadioField
                  name="isInput"
                  options={[{ value: false, label: '基本料率' }, { value: true, label: '直接入力' }]}
                  normalize={value => value === 'true'}
                  onChange={(e, value) => {
                    // チェックをOFFにしたタイミングで、税率マスタの値にリセットする
                    // (handleInsuranceTypeChangeは、内部ではinputの値に税率マスタをセットする関数なのでリセット目的で使用)
                    if (value === false) {
                      handleInsuranceTypeChange(selectedInsuranceType, settingStartDate, insuranceTypes);
                    }
                  }}
                />
              </div>
            )}
            <div className="l-overflow-scroll">
              <table className={`${styles.table} m-table-list`}>
                <thead>
                  <tr>
                    <th className={styles.name}>保険名</th>
                    <th>従業員負担（％）</th>
                    <th>事業主負担（％）</th>
                    <th className={styles.sum}>合計（％）</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>労災保険料</td>
                    <td>
                      <TextField type="text" name="premiumRateForEmployee" validate={digitFloatingNumber} disabled />
                    </td>
                    <td>
                      <TextField
                        noLabel
                        type="text"
                        name="premiumRateForEmployer"
                        label="税率"
                        maxLength={8}
                        validate={isAccidentInsuranceRateFormat}
                        disabled={!isInput}
                      />
                    </td>
                    <td>
                      <span>{toFloatString(sumFloatNumberFixed5(premiumRateForEmployee, premiumRateForEmployer))}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="u-ta-c u-mt20">
            <Button primary disabled={submitting} onClick={submit}>
              保存
            </Button>
          </div>
        </form>
      </InsuranceSetting>
    </div>
  );
};
export default AccidentInsuranceCreatingForm;
